module.exports = __webpack_public_path__ + "media/logos/SENL_LOGO-6aaf5d29.png";